<template>
 	<b-container fluid>
        <b-row>
            <b-container fluid>
                <h3>Transaction Ledger</h3>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.transactions.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.transactions.filter" @click="tables.transactions.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6" class="buttons-create">
                        <!-- <b-button variant="outline-primary" size="sm" @click="exportproducts()">Export</b-button> -->
                        <b-button variant="outline-primary" size="sm" @click="">Export</b-button>
                    </b-col>

<!--                         <b-col cols="3">
                        <treeselect
                            name="categoriesSelect"
                            class="categoriesSelect"
                            clearable
                            :searchable="false"
                            open-on-click
                            clear-on-select
                            close-on-select
                            disableBranchNodes
                            placeholder="Filter by Category"
                            :options="categories"
                            @input="filterByCategory"
                            />
                    </b-col> -->

                    <b-col cols="3">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.transactions.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.transactions.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                

                <b-row class="row-transactions-table">
                    <b-container fluid>
                        <b-table
                            :key="tables.transactions.key"
                            class="transactions-table"
                            responsive bordered
                            hover no-border-collapse
                            sticky-header="600px"
                            head-variant="light"
                            :items="tables.transactions.items" :fields="tables.transactions.fields"
                            :sort-by="tables.transactions.sortBy"
                            :sort-desc="tables.transactions.sortDesc"
                            :per-page="tables.transactions.perPage"
                            :current-page="tables.transactions.currentPage"
                            :filter="tables.transactions.filter"
                            @filtered="onFiltered"
                            :busy="tables.transactions.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <!-- <template v-slot:cell(thumb)="row">
                                <b-img-lazy v-if="row.item.image_small && row.item.image_small.length" class="products-thumbs" :src="'/storage/images/' + row.item.sku + '/' + row.item.image_small"></b-img-lazy>
                            </template> -->

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <b-col>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.transactions.currentPage"
                          :total-rows="tables.transactions.totalRows"
                          :per-page="tables.transactions.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>
    </b-container>
 	</div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
 	export default {
    	name: 'TransactionLedger',
    	components: {
      		Treeselect
    	},
        data() {
            return {
                categories: [],
                tables: {
                    transactions: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'date',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        fields: [
                            {
                                key: 'date',
                                label: 'Date',
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'type',
                                label: 'SKU'
                            },
                            {
                                key: 'reference_id',
                                label: 'Reference ID'
                            },
                            {
                                key: 'source',
                                label: 'Source'
                            },
                            {
                                key: 'name',
                                label: 'Name'
                            },
                            {
                                key: 'notes',
                                label: 'Notes'
                            },
                            {
                                key: 'sku',
                                label: 'SKU'
                            },
                            {
                                key: 'qty',
                                label: 'QTY'
                            },
                            {
                                key: 'qty_previous',
                                label: 'QTY Before'
                            },
                            {
                                key: 'location',
                                label: 'Location'
                            },
                            {
                                key: 'submitted_by',
                                label: 'Submitter'
                            },
                            {
                                key: 'not_matched',
                                label: 'No Match'
                            },
                            {
                                key: 'void',
                                label: 'Void'
                            },
                            {
                                key: 'voided',
                                label: 'Voided'
                            },
                            {
                                key: 'processed',
                                label: 'Processed'
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'transactions-table-style-actions'
                            }
                        ],

                        items: []
                    },
                },
            }
        },
        methods: {
            toggleBusy() {
                this.tables.transactions.isBusy = !this.tables.transactions.isBusy
            },

            getTransactions(id, silent) {
                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/reporting/transactionledger/getledger'
                axios.post(url, {
                    id: id
                })
                .then((res) => {
                    if (res.data.transactions.length) {
                        this.tables.transactions.items = res.data.items
                        this.tables.transactions.totalRows = this.tables.transactions.items.length
                    }

                    if (!silent) {
                        this.toggleBusy()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            // filterByCategory(catId) {
            //     this.getProducts(catId)
            // },

            // findCategoryName(id) {
            //     let index = this.findIndex(this.categories, 'id', id)
            //     return this.categories[index].label
            // },

            // getCategories() {
            //     let url = 'api/products/getcategoriesfilter'
            //     axios.get(url, {})
            //     .then((res) => {
            //         this.categories = res.data.categories
            //     }, () => {
            //         this.has_error = true
            //     })
            // },

            onFiltered(filteredItems) {
                this.tables.transactions.totalRows = filteredItems.length
                this.tables.transactions.currentPage = 1
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.transactions.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.transactions.totalRows
                let currentPage = this.tables.transactions.currentPage
                let perPage = this.tables.transactions.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.transactions.totalRows + ' rows'
            }
	    },
	    mounted() {
            this.getTransactions()
            // this.getCategories()

            // pusher
            Echo.channel('table-transaction-ledger-updated')
                .listen('TableTransactionLedgerUpdated', (e) => {
                this.getTransactions(null, 1)
            })
	    }
  }
</script>
<style lang="scss">
    .buttons-create {

    }

    .categoriesSelect {
        .vue-treeselect__control {
            height: calc(1.5em + 0.5rem + 2px);
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
            padding-left: 0.5rem;
            font-size: 0.7875rem;

            .vue-treeselect__placeholder, .vue-treeselect__single-value {
                line-height: 1.5
            }
        }
    }

    .transactions-table {
        .transactions-table-style-actions {
            width: 120px;
        }
    }
</style>